
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

interface LogoutButtonProps {
  onClick?: () => void;
  className?: string;
}

export const LogoutButton = ({ onClick, className }: LogoutButtonProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Logged out successfully",
      });
      navigate("/auth");
    } catch (error) {
      toast({
        title: "Error logging out",
        variant: "destructive",
      });
    }
    
    if (onClick) onClick();
  };

  return (
    <button
      onClick={handleLogout}
      className={`flex items-center transition-colors text-gray-600 hover:bg-gray-100 ${className}`}
    >
      <LogOut className="w-5 h-5 mr-2" />
      <span className="md:inline text-sm">Logout</span>
    </button>
  );
};
